import $ from 'jquery';

class TargetBlankLinks {
    constructor () {
        this.$chapterLinks = $('.js-chapter a');

        this.findLinks();
    }

    findLinks () {
        this.$chapterLinks.not('.js-note-marker').attr('target', '_blank');
    }
}

export default TargetBlankLinks;
